<template>
    <div class="sportsSwitch" v-bind:class="{ _show: sportsListShow, _INStyle: i18n.locale.value === LanguageType.TA_IN || i18n.locale.value === LanguageType.HI_IN }">
        <div id="sportsSwitchEl" class="sportsSwitch-function">
            <div class="sportsSwitch-toggle JARVIS_Header2_DropDown_FeatureSports">
                <span sportsel-TA_IN="" style="font-size: 1.5em;" />

                <div
                    class="sportsSwitch-dropDown"
                    v-on:click="toggleSportsList"
                >
                    <span>
                        {{ sportsSwitchTitle }}
                    </span>
                    <div class="sportSwitch-arrowUpAndDown" />
                </div>
            </div>
            <div
                v-if="!isInOtherProduct"
                class="sportsMixParlay"
            >
                <MixParlayToggle v-on:switchMpMode="switchMpMode" />
            </div>
        </div>
        <SportsSwitchList
            v-if="sportsListShow"
            v-bind:sportsInfo="sportsInfo"
            v-bind:loading="loading"
            v-bind:refetch="refetch"
            v-bind:isInOtherProduct="isInOtherProduct"
            v-on:close="closeSportsList"
        />
    </div>
</template>

<script lang="ts" setup>
    import { onMounted, ref } from 'vue';
    import MixParlayToggle from '@/components/MixParlayToggle.vue';
    import SportsSwitchList from '@/components/sportsSwitch/SportsSwitchList.vue';
    import { LanguageType } from '@/interface/enum';
    import useScroll from '@/libraries/composables/useScroll';
    import { useSportsSwitch } from '@/libraries/composables/useSportsSwitch';
    import { i18n } from '@/libraries/i18n';
    import { useSportsInfoQuery } from '@/libraries/oddsApi/composables/useSportsInfoQuery';

    interface Props {
        isInOtherProduct?: boolean;
    }

    const props = withDefaults(defineProps<Props>(), {
        isInOtherProduct: false,
    });

    const sportsListShow = ref(false);

    const { sportsInfo, refetch, loading } = useSportsInfoQuery(sportsListShow);
    const { sportsSwitchTitle, switchMpMode } = useSportsSwitch(props.isInOtherProduct);

    function closeSportsList() {
        sportsListShow.value = false;
    }

    function toggleSportsList() {
        sportsListShow.value = !sportsListShow.value;
    }

    onMounted(() => {
        const { initHeaderDisplayHeight } = useScroll();
        initHeaderDisplayHeight(() => document.getElementById('sportsSwitchEl'), 'sportSwitchHeight');
    });
</script>

<style lang="scss" scoped>
@import "@/scss/components/sportsSwitch";
</style>
